import { EstateContactMessageProps } from '../../ApiClientTypes';

export const mapEstateContactRequestProps = (contactMessage: EstateContactMessageProps): EstateContactMessageProps => {
  return contactMessage;
};
